var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.154 1.215a4.694 4.694 0 0 1 6.63 6.63l-3.572 3.945a5.471 5.471 0 0 0-1.407 3.982l.12 2.138a1.978 1.978 0 0 1-3.373 1.51l-3.578-3.578-.38.344a1.969 1.969 0 0 1-2.78-2.78l.344-.38L.579 9.448a1.978 1.978 0 0 1 1.51-3.374l2.14.121A5.471 5.471 0 0 0 8.21 4.788l3.944-3.573Zm-.966 3.676a.596.596 0 0 0-.767-.063L7.987 6.566a.595.595 0 0 1-.23.1l-2.995.599a.596.596 0 0 0-.305 1.005l7.272 7.273a.596.596 0 0 0 1.006-.305l.599-2.995a.598.598 0 0 1 .1-.23l1.738-2.434a.596.596 0 0 0-.063-.768l-3.92-3.92Z",
    fill: "#D2AE6D"
  })));
};
export default SvgBell;